import { HasId } from '../interfaces';
import { Survey } from './Survey';

export class SurveyReportType implements HasId {
    public id: number;
    public name: string;
    public sort: number;
    public default: boolean;
    public surveyID: number;
    public survey: Survey;
}

export class UserReportType {
    public id: number;
    public userID: number;
    public surveyReportTypeID: number;
    public surveyReportType?: SurveyReportType;
}


// WEBPACK FOOTER //
// ./src/models/SurveyReportType.tsx